import ICaseSummary from "@myinnsworth/models/case/ICaseSummary";
import IContact from "@myinnsworth/models/contact/IContact";
import IUser from "@myinnsworth/models/user/IUser";
import { createContext } from "react";

export enum AuthenticationState {
    SignedIn = 0,
    Authenticating = 1,
    TokenRefresh = 2,
    SignedOut = 3
}

export interface IAuthenticationContext {
    user?: IUser | null;
    contact?: IContact | null;
    userCases?: Array<ICaseSummary> | null;
    state: AuthenticationState;
}

const AuthenticationContext = createContext<IAuthenticationContext>({ state: AuthenticationState.TokenRefresh});
export default AuthenticationContext;